import { NgModule } from "@angular/core";
import { EntityDataModule } from "@ngrx/data";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { GatewayEffects } from "../core/state/gateway.effect";
import { sharedNumberReducer } from "../core/state/gateway.reducer";
import { NotificationEffects } from "../core/state/notification.effect";
import { notificationsStateReducer } from "../core/state/notification.reducer";
import { RouteEffect } from "../core/state/route/route.effect";
import { routeReducer } from "../core/state/route/route.reducer";
import { SystemSettingsEffects } from "../core/state/system-settings.effect";
import { systemSettingsReducer } from "../core/state/system-settings.reducer";
import { GlobalSettingsEffects } from "../reminders/reminder-settings/global-settings/state/global-settings.effects";
import {
  GlobalSettingsReducer,
  STORE_FEATURE_KEY_GLOBAL,
} from "../reminders/reminder-settings/global-settings/state/global-settings.reducer";

@NgModule({
  imports: [
    StoreModule.forRoot({}), // Do this BEFORE registering any store modules or reducers
    EffectsModule.forRoot([]), // Necessary before registering forFeature effects
    EntityDataModule.forRoot({}),

    // TODO: Disable in production?
    StoreDevtoolsModule.instrument({
      maxAge: 100,
    }),

    // TODO: Move into feature modules
    StoreModule.forFeature("route", routeReducer),
    StoreModule.forFeature("systemSettings", systemSettingsReducer),
    StoreModule.forFeature("gateway", sharedNumberReducer), // stores availableDevices, sharedNumbers, etc.

    StoreModule.forFeature("notification", notificationsStateReducer),

    // StoreModule.forFeature('twoWay', twoWayStateReducer), // TODO: This can't be part of lazy loaded module! Not if part of the state is used by navbar
    EffectsModule.forFeature([RouteEffect]),
    EffectsModule.forFeature([SystemSettingsEffects]),
    EffectsModule.forFeature([GatewayEffects]),
    EffectsModule.forFeature([NotificationEffects]),

    // TODO: Move to an module common for "reminder" features
    StoreModule.forFeature(STORE_FEATURE_KEY_GLOBAL, GlobalSettingsReducer),
    EffectsModule.forFeature([GlobalSettingsEffects])
  ],
  declarations: [],
  providers: []
})
export class StateModule {}
